import {
  DashboardKitData,
  GetDashboardKitDataRequestDto,
  GetTurnDetailRowsByTaskAndStoreForPortalTouchKitRequestDto,
  TurnDetailRowForPortalTouchKitRow,
} from 'scenes/Kit/Dashboard/types';
import {
  AttendanceUserTurnDetail,
  DashboardKitAlternativeModeData,
  GetDashboardKitAlternativeModeDataRequestDto,
} from 'scenes/Kit/DashboardAlternativeMode/types';

import { ApiErrorData, ApiResponse } from 'models/ApiResponse';
import { KitCampaign } from 'models/KitCampaign';

import { FunctionsHelper } from 'utils/FunctionsHelper';
import MainBackendAxios from 'utils/MainBackendAxios';

export const KitCampaignService = {
  getByCompany: async (
    companyId: number
  ): Promise<ApiResponse<KitCampaign[] | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(
        `/campaign/get-by-company/${companyId}`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data as KitCampaign[],
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  getByCurrentUser: async (): Promise<
    ApiResponse<KitCampaign[] | ApiErrorData>
  > => {
    try {
      const response = await MainBackendAxios.get(
        `/campaign/get-by-current-user`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data as KitCampaign[],
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  /** Campañas (tasks) de TouchLatam por país — catálogo amplio para operación. */
  getByCountry: async (
    countryCode: string
  ): Promise<ApiResponse<KitCampaign[] | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(`/requisition/tasks`, {
        params: { country: countryCode },
      });

      return {
        success: true,
        status: response.status,
        data: response?.data?.data as KitCampaign[],
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  getDashboardKitData: async (
    body: GetDashboardKitDataRequestDto
  ): Promise<ApiResponse<DashboardKitData | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/campaign/kit/get-dashboard-data`,
        body
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data as DashboardKitData,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  getDashboardKitAlternativeModeData: async (
    body: GetDashboardKitAlternativeModeDataRequestDto
  ): Promise<ApiResponse<DashboardKitAlternativeModeData | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/campaign/kit/get-dashboard-data-go-mode`,
        body
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data as DashboardKitAlternativeModeData,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  findAttendanceUserTurnDetailByCompositeKey: async (compositeKey: {
    userId: number;
    turnId: number;
  }): Promise<ApiResponse<AttendanceUserTurnDetail | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/campaign/kit/find-attendance-detail-by-composite-key`,
        compositeKey
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data as AttendanceUserTurnDetail,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  getTouchLatamApiUrl: async (): Promise<
    ApiResponse<{ url: string } | ApiErrorData>
  > => {
    try {
      const response = await MainBackendAxios.get(
        `/campaign/get-touchlatam-api-url`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data as { url: string },
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  getTurnDetailRowsByTaskAndStoreForPortalTouchKit: async (
    body: GetTurnDetailRowsByTaskAndStoreForPortalTouchKitRequestDto
  ): Promise<
    ApiResponse<TurnDetailRowForPortalTouchKitRow[] | ApiErrorData>
  > => {
    try {
      const response = await MainBackendAxios.post(
        `/campaign/kit/get-turn-detail-rows-by-task-and-store`,
        body
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data as TurnDetailRowForPortalTouchKitRow[],
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
};
